import TextAreaField from '../../../components/Forms/Input/TextAreaField';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';
import { useProductSettlement } from '../../../hooks/settlement/useProductSettlement';

const ImportPurchaseFinalizeSection = () => {
  const {
    form,
    updateField,
    handlerFinalizePurchase,
    isSubmitting,
    purchaseSettlementLoaded,
  } = useBasePurchase();

  const { handlerFinalizeSettlement } = useProductSettlement();

  return (
    <div className="mt-6 w-full rounded-sm border border-stroke bg-white p-6.5 shadow-default dark:border-strokedark dark:bg-boxdark">
      <TextAreaField
        name="comments"
        label="Comentarios (Uso Interno)"
        placeholder="Comentarios/Observaciones sobre la importación"
        value={form.comments || ''}
        disabled={purchaseSettlementLoaded} // ✅ deshabilitado si ya se asentó
        onChange={(e) => updateField('comments', e.target.value)}
      />

      <div className="mt-4 flex justify-end">
        {purchaseSettlementLoaded ? (
          <button
            type="button"
            onClick={handlerFinalizeSettlement}
            className="rounded bg-primary px-4 py-2 text-white hover:bg-opacity-90"
          >
            Asentar Productos
          </button>
        ) : (
          <button
            type="button"
            onClick={handlerFinalizePurchase}
            disabled={isSubmitting}
            className={`rounded px-4 py-2 text-white transition-colors ${
              isSubmitting
                ? 'cursor-not-allowed bg-primary/80'
                : 'bg-primary hover:bg-opacity-90'
            }`}
          >
            {isSubmitting ? 'Finalizando...' : 'Finalizar Compra'}
          </button>
        )}
      </div>
    </div>
  );
};

export default ImportPurchaseFinalizeSection;
